import * as React from 'react';

export default () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
        >
          <path d="M12.085 10.663a.726.726 0 01-.514-1.242l1.938-1.938a3.484 3.484 0 001.037-2.496 3.537 3.537 0 00-3.533-3.532c-.947 0-1.833.367-2.494 1.034l-1.94 1.94A.726.726 0 115.55 3.401l1.938-1.938A4.925 4.925 0 0111.013 0 4.992 4.992 0 0116 4.987c0 1.339-.52 2.591-1.466 3.527l-1.936 1.935a.724.724 0 01-.513.214zM4.987 16A4.992 4.992 0 010 11.013c0-1.339.52-2.591 1.466-3.527L3.4 5.551A.726.726 0 114.43 6.579L2.492 8.517a3.482 3.482 0 00-1.037 2.496 3.537 3.537 0 003.532 3.533c.947 0 1.833-.368 2.494-1.035l1.94-1.94a.726.726 0 111.028 1.028l-1.938 1.939A4.925 4.925 0 014.987 16z"></path>
          <path d="M5.09 11.636a.727.727 0 01-.514-1.241l5.819-5.818a.726.726 0 111.028 1.028l-5.818 5.818a.725.725 0 01-.514.213z"></path>
        </svg>
    );
}